import React from "react";
import "../../styles/renewal/renewal.scss";

import logoBlack from "../../public/assets/img/Otters_home_logo_black.png";
import dolce from "../../public/assets/img/dolce.png";
import latte from "../../public/assets/img/latte.png";
import mocha from "../../public/assets/img/mocha.png";
import toffee from "../../public/assets/img/toffee.png";
import naverLogo from "../../public/assets/img/naver_logo.png";
import shopLogo from "../../public/assets/img/shop_logo.png";

const RenewalPage = () => {
	return (
		<div className='renewal-page'>
			{/* Hero Section */}
			<section className='hero-section'>
				<div className='logo-container'>
					<img src={logoBlack} alt='이웃집수달 로고' className='main-logo' />
				</div>

				<div className='character-container'>
					<img src={dolce} alt='돌체 수달' className='character character-1' />
					<img src={latte} alt='라떼 수달' className='character character-2' />
					<img src={mocha} alt='모카 수달' className='character character-3' />
					<img src={toffee} alt='토피 수달' className='character character-4' />
				</div>

				<div className='message-container'>
					<h1 className='main-copy'>
						더 나은 모습으로 만나기 위해,
						<br />
						<strong>이웃집수달 웹사이트 리뉴얼 중</strong>입니다.
					</h1>
					<p className='sub-copy'>
						잠시만 기다려 주세요!
						<br />곧 멋진 모습으로 돌아오겠습니다.
					</p>
				</div>
			</section>

			{/* Info Section - 관람 안내 */}
			<section className='info-section'>
				<div className='section-content'>
					<h2 className='section-title'>수달 친구들을 직접 만나고 싶으신가요?</h2>
					<p className='section-description'>
						방문 안내, 위치, 영업시간을 확인하고
						<br />
						네이버에서 예약하실 수 있습니다.
					</p>
					<a
						href='https://naver.me/53lKw58s'
						className='cta-button naver-button'
						role='button'
						aria-label='네이버에서 관람 정보 확인 및 예약하기'>
						<img src={naverLogo} alt='네이버' className='button-icon' />
						<span>관람 정보 및 예약하기</span>
					</a>
				</div>
			</section>

			{/* Shop Section - 쇼핑몰 안내 */}
			<section className='shop-section'>
				<div className='section-content'>
					<h2 className='section-title'>
						귀여운 수달 굿즈와 애견 용품이 가득한
						<br />
						<strong>이웃집수달샵</strong>은 지금도 열려 있어요!
					</h2>
					<p className='section-description'>
						사랑스러운 수달 캐릭터 굿즈와
						<br />
						반려동물을 위한 특별한 제품들을 만나보세요.
					</p>
					<a
						href='https://smartstore.naver.com/ottershome'
						className='cta-button shop-button'
						role='button'
						aria-label='이웃집수달샵 쇼핑하러 가기'>
						<img src={shopLogo} alt='이웃집수달샵' className='button-icon' />
						<span>이웃집수달샵 쇼핑하러 가기</span>
					</a>
				</div>
			</section>

			{/* Footer */}
			<footer className='renewal-footer'>
				<p className='footer-text'>© 2024 이웃집수달. All rights reserved.</p>
			</footer>
		</div>
	);
};

export default RenewalPage;
